import { DirectionProvider as RadixDirectionProvider } from '@radix-ui/react-direction'
import React from 'react'
import { useTranslation } from 'react-i18next'

const DirectionProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const { i18n } = useTranslation()
  const direction = i18n.dir()

  return (
    <RadixDirectionProvider dir={direction}>
      <div dir={direction}>{children}</div>
    </RadixDirectionProvider>
  )
}

export default DirectionProvider
